import { properties } from "@repoflow/common/schema-fields";

const { createdAt, updatedAt } = properties;

export { createdAt, updatedAt };

// The hostname a visitor types, lowercased, and the table's whole primary key.
//
// HASH-ONLY, AND THAT IS THE POINT
//
// Every other table here is partitioned by the tenant — `orgId`, or the
// composite `${orgId}/${siteId}` — because that is what keeps one organization's
// rows unreachable from another's. This one cannot be, and must not be: a
// hostname is global. Two organizations claiming `example.com` is exactly the
// collision the table exists to refuse, and it can only refuse it if both
// claims land on the same key.
//
// So tenancy is enforced on the way OUT instead. Every read that belongs to an
// organization filters on the row's own `orgId`; see model/site-domain.
export const host = {
  label: "Domain",
  $ref: "/SiteDomain/Host",
};

export const orgId = {
  type: "string",
};

// `${orgId}/${siteId}`, the same composite pages and sections are partitioned
// by — see @common/schema/site/key. Here it is not the partition, because the
// partition has to be the hostname; it is the key of the `siteKey-index` GSI,
// which is what answers "every domain attached to this site" in one query on a
// table whose own key is global.
export { siteKey } from "@common/schema/site/key";

// Which site of that organization the hostname serves. Chosen by the caller in
// the same sense `siteId` always is — the row is created beneath a site that was
// already resolved from the caller's own organization.
export const siteId = {
  type: "string",
};

export const status = {
  type: "string",
};

// What the TXT record has to contain. Minted once, at create, and never shown to
// anyone but the organization that owns the row — a token a third party could
// read is a token a third party could publish.
export const token = {
  type: "string",
};

export const verifiedAt = {
  type: "string",
  default: "",
};

// DynamoDB's TTL attribute: epoch SECONDS, and a number rather than the ISO
// strings every other timestamp here uses, because TTL is read by DynamoDB
// itself and it accepts nothing else.
//
// Written on a pending row and REMOVED when the row goes active. Without it a
// claim nobody ever verifies is permanent, and since the table is global that
// is a way to take a hostname away from whoever actually owns it — squat
// `competitor.com`, never publish the TXT record, and no other organization can
// ever attach it. Expiry is what keeps an unproven claim cheap to make and
// impossible to hold.
export const expiresAt = {
  type: "integer",
};

export default [
  {
    id: "/SiteDomain/Host",
    type: "string",
    maxLength: 253,
    // Lowercase only, at least two labels, no scheme, no port, no path, no
    // trailing dot. Lowercase is a CONSTRAINT and not a courtesy: the host is
    // the primary key, so `Example.com` and `example.com` would be two rows and
    // two claims on one name. The model lowercases before it validates, so a
    // caller typing capitals is corrected rather than rejected.
    pattern: "^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)+$",
  },
];
